(function () {
    var items = document.querySelector(".header__inline-menu").querySelectorAll("details"),
        timer = null;
    items.forEach(function(item) {
        item.addEventListener("mouseover", () => {
            clearTimeout(timer);
            item.setAttribute("open", true);
          });
        item.querySelector("ul").addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
        item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
        item.querySelector(".header__menu-item").addEventListener("click", (event) => {
            var summary = event.target.closest('.header__menu-item');
            if (summary.dataset.href != null) {
                item.setAttribute("open", true);
                window.location = item.querySelector('summary').dataset.href;
            }
        })
     });
})()